const GA_CATEGORY_BUTTON_CLICK = 'button_click';

export {
  GA_CATEGORY_BUTTON_CLICK
}